export const LANDING = {
  navLogo: "nav-logo",
  navDownloadBtn: "nav-download-btn",
  navMenuToggle: "nav-menu-toggle",
  navLinkFeatures: "nav-link-features",
  navLinkPricing: "nav-link-pricing",
  navLinkStory: "nav-link-story",

  heroDownloadBtn: "hero-download-btn",
  heroViewFeaturesBtn: "hero-view-features-btn",
  heroPhoneMockup: "hero-phone-mockup",

  storySectionDownloadBtn: "story-download-btn",

  featurePipelineCard: "feature-pipeline-card",
  featureWhatsappCard: "feature-whatsapp-card",
  featureBuilderCard: "feature-builder-card",
  featureTrackingCard: "feature-tracking-card",

  pricingFreeBtn: "pricing-free-btn",
  pricingPremiumBtn: "pricing-premium-btn",

  ctaDownloadBtn: "final-cta-download-btn",

  footerPrivacyLink: "footer-privacy-link",
  footerDataDeletionLink: "footer-data-deletion-link",
  footerTermsLink: "footer-terms-link",
  footerContactLink: "footer-contact-link",
  footerDownloadBtn: "footer-download-btn",
  footerEmailLink: "footer-support-email-link",

  privacyPolicyPage: "privacy-policy-page",
  termsPage: "terms-and-conditions-page",
  dataDeletionPage: "data-deletion-page",
  dataDeletionEmailBtn: "data-deletion-email-btn",
  legalBackHomeBtn: "legal-back-home-btn",
};
